"use client";

import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import type { FC } from "react";
import { useChatbotVisibility } from "../chat-bot/chatbot-experiment";
import { useChatBotNavigation } from "../chat-bot/navigation";
import { trackChatbotIconClicked } from "../chat-bot/tracking";
type SupportContactClassNames = {
  phone: string;
  phoneIcon: string;
  phoneText: string;
  support: string;
  title: string;
};
type SupportContactProperties = {
  classNames: SupportContactClassNames;
  phoneNumber: {
    text: string;
    value: string;
  };
};
const ChatbotSupportButton: FC<{
  className: string;
}> = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  const navigation = useChatBotNavigation();
  let t1;
  if ($[0] !== navigation) {
    t1 = () => {
      navigation.open();
      trackChatbotIconClicked("support_call");
    };
    $[0] = navigation;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSupportClick = t1;
  let t2;
  if ($[2] !== className || $[3] !== handleSupportClick) {
    t2 = <button className={className} onClick={handleSupportClick} type="button">ارتباط با پشتیبانی</button>;
    $[2] = className;
    $[3] = handleSupportClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const SupportContact: FC<SupportContactProperties> = t0 => {
  const $ = _c(19);
  const {
    classNames,
    phoneNumber
  } = t0;
  const showChatbot = useChatbotVisibility();
  const isVisibilityPending = showChatbot === null;
  const t1 = isVisibilityPending || undefined;
  const t2 = `${classNames.support} ${isVisibilityPending ? "invisible" : ""}`;
  const t3 = showChatbot ? "\u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0622\u0646\u0644\u0627\u06CC\u0646 \u06F2\u06F4 \u0633\u0627\u0639\u062A\u0647" : "\u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u06F2\u06F4 \u0633\u0627\u0639\u062A\u0647 \u0648 \u06F7 \u0631\u0648\u0632 \u0647\u0641\u062A\u0647";
  let t4;
  if ($[0] !== classNames.title || $[1] !== t3) {
    t4 = <div className={classNames.title}>{t3}</div>;
    $[0] = classNames.title;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== classNames.phoneText || $[4] !== phoneNumber || $[5] !== showChatbot) {
    t5 = showChatbot ? <ChatbotSupportButton className={classNames.phoneText} /> : <a className={classNames.phoneText} href={`tel:${phoneNumber.value}`}>{numberConvert(phoneNumber.text, {
        numberOnly: false,
        locale: "fa"
      })}</a>;
    $[3] = classNames.phoneText;
    $[4] = phoneNumber;
    $[5] = showChatbot;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== classNames.phoneIcon || $[8] !== showChatbot) {
    t6 = !showChatbot && <div className={classNames.phoneIcon}><MaterialIcon name="phone" /></div>;
    $[7] = classNames.phoneIcon;
    $[8] = showChatbot;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== classNames.phone || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className={classNames.phone}>{t5}{t6}</div>;
    $[10] = classNames.phone;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t4 || $[17] !== t7) {
    t8 = <div aria-hidden={t1} className={t2}>{t4}{t7}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};